import { Endpoint, EndpointWithoutRequest, Http } from "Application";
import { UserModel } from "../UserModel";
import { Moment } from "moment";
import UserDetailsViewModel from "../UserDetail/UserDetailsViewModel";
import { runInAction } from "mobx";

class Response {
    public id: Guid | null = null;
    public firstName: string = "";
    public lastName: string = "";
    public email: string = "";
    public password: string = "";
    public role: string = "";
    public developmentId: string = "";
    public plotId: string = "";
    public userPlotId: string | null = "";
    public concurrencyToken: string = "";
    public isDeleted: boolean = false;
    public lastLoginDate: Moment | null = null;
    public userRoles: string[] = [];
}

export class GetUserByIdEndpoint extends EndpointWithoutRequest<Response> {
    private viewModel: UserDetailsViewModel;
    constructor(viewModel: UserDetailsViewModel, userId: string) {
        super();
        this.viewModel = viewModel;
        this.verb(Http.Get);
        this.path(`/api/user/getUserById/${userId}`);
    }

    public async HandleResponseAsync(response: Response): Promise<UserModel> {
        let userModel: UserModel = new UserModel(response.id);
        runInAction(() => {
            userModel.fromResponse(response);
            userModel.userRoles.replace(response.userRoles);
            this.viewModel.setModel(userModel);
        });
        return userModel;
    }
}
